import React from 'react';
import styled from 'styled-components';
import { format, parseISO } from 'date-fns';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { User } from '@mytypes';
import { FONT_WEIGHTS, FONT_SIZES, PALETTE } from '~/assets/styles/base';
import { INDIVIDUAL_CATEGORY_NAME } from '~/common/constants';
import { USER_TABLE_HEAD } from '~/constants';

const StyledTable = styled(Table)`
  min-width: 1260px;
`;

const StyledTableHead = styled(TableHead)`
  background-color: ${PALETTE.blue.main};
  border: 1px solid ${PALETTE.border.table};
  border-width: 2px 1px 2px 1px;
  th {
    font-size: ${FONT_SIZES.body3};
    font-weight: ${FONT_WEIGHTS.base};
    height: 36px;
    padding: 10px 12px;
    vertical-align: middle;
    white-space: nowrap;
  }
`;

const StyledTableBody = styled(TableBody)`
  border: 1px solid ${PALETTE.border.table};
  border-top: none;
  tr {
    background-color: ${PALETTE.white};
    &:nth-child(even) {
      background-color: ${PALETTE.blue.light};
    }
  }
  td {
    font-size: ${FONT_SIZES.body3};
    height: 44px;
    padding: 10px 12px;
    border-bottom: 1px solid ${PALETTE.border.table};
  }
`;

type Props = {
  users: User[];
};

const InfoListTable: React.FC<Props> = ({ users }): JSX.Element => (
  <TableContainer>
    <StyledTable>
      <StyledTableHead>
        <tr data-testid="UsersInfoListTableHead">
          {USER_TABLE_HEAD.map((elem) => (
            <TableCell key={elem.id}>{elem.text}</TableCell>
          ))}
        </tr>
      </StyledTableHead>
      <StyledTableBody>
        {users.map((user, i) => (
          <TableRow key={user.id} data-testid={`UsersInfoListTableRow-${i}`}>
            <TableCell component="td" scope="row">
              {user.id}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.name}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.email}
            </TableCell>
            <TableCell component="td" scope="row">
              {INDIVIDUAL_CATEGORY_NAME[user.individualCategory]}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.companyName}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.departmentName}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.zip}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.pref}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.address}
            </TableCell>
            <TableCell component="td" scope="row">
              {user.phone}
            </TableCell>
            <TableCell component="td" scope="row">
              {format(parseISO(user.created), 'yyyy/MM/dd HH:mm')}
            </TableCell>
          </TableRow>
        ))}
      </StyledTableBody>
    </StyledTable>
  </TableContainer>
);

export default InfoListTable;
